import { Image, UIHeading4, UIText1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { INewbuildingOffer } from 'shared/types/newbuildingOffersCarousel';

import * as styles from './styles.css';
import { Underground } from '../Underground';

export interface INewbuildingOfferCardProps extends INewbuildingOffer {
  onNewbuilldingClick?(): void;
  onOfferClick?(): void;
}

export function NewbuildingOfferCard({
  imageUrl,
  cardUrl,
  priceDisplay,
  newbuilding,
  underground,
  description,
  newbuildingAddress,
  companyLogoUrl,
  onNewbuilldingClick,
  onOfferClick,
}: INewbuildingOfferCardProps) {
  return (
    <div className={styles['container']}>
      <a
        href={cardUrl}
        target="_blank"
        rel="noreferrer"
        data-testid="NewbuildingOfferCardLink"
        className={styles['link']}
        onClick={onOfferClick}
      >
        <div className={styles['preview']}>
          <Image src={imageUrl} objectFit="contain" height={140} borderRadius={0} />
        </div>
        {companyLogoUrl && (
          <div data-testid="newbuilding_card_company_logo" className={styles['logo']}>
            <Image src={companyLogoUrl} objectFit={'cover'} alt="логотип" borderRadius="4px" preloader={false} />
          </div>
        )}
        <div className={styles['content']}>
          <UIHeading4 as="h5" whiteSpace="nowrap">
            {priceDisplay}
          </UIHeading4>

          <div className={styles['price']}>
            <UIText1>{description}</UIText1>
          </div>
          {underground && (
            <Underground
              lineColor={underground.lineColor}
              name={underground.name}
              transportType={underground.transportType}
              cityType={underground.cityType}
              timeDisplay={underground.timeDisplay}
            />
          )}
          {newbuildingAddress && (
            <div data-testid="NewbuildingOfferCardAddress" className={styles['address']}>
              <UIText2 color="text-secondary-default">{newbuildingAddress}</UIText2>
            </div>
          )}
        </div>
      </a>
      {newbuilding && (
        <a
          className={styles['link-newbuilding']}
          target="_blank"
          data-testid="NewbuildingOfferCardJk"
          rel="noreferrer"
          href={newbuilding.url}
          onClick={onNewbuilldingClick}
        >
          <UIText2 color="text-main-default">{newbuilding.name}</UIText2>
        </a>
      )}
    </div>
  );
}
